import React, { Component } from 'react';
import Select from 'react-select';
import { FormGroup, Col, Label } from 'reactstrap';
import { getMedicalRecordByDocument } from '../../services'
import { medicalDocument, medicalTableHeader } from '../configData'
import MedicalTable from './MedicalTable';

class ShareMedicalRecord extends Component {
  
  state = {
    document: null
  } 

  async componentDidMount() {
  
  }

  handleDocument = async (selectedDocument) => {
    let data = {
      type: selectedDocument['value']
    }
    const response = await getMedicalRecordByDocument(data);
    this.setState(prevState => ({
      records: response.data.records,
      document: selectedDocument['value']
    }))
  }

  render() {

    const { document, records } = this.state

    return (
      <React.Fragment>
        <Col md="4">
          <FormGroup>
            <Label>Select document type</Label>
            <Select 
              options={medicalDocument}
              onChange={this.handleDocument}
            />
          </FormGroup>
        </Col>
        {document !== null &&
          <Col md="12">
            <MedicalTable records={records}/>
          </Col>
        }
      </React.Fragment>
    )
  }
}

export default ShareMedicalRecord;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ShareMyRecord/ShareMedicalRecord.js